export const COMPANY = {
  name: "Crestline Risk Management",
  legalName: "Crestline Risk Management Pvt. Ltd.",
  tagline: "Your Trusted Collection & Recovery Partner",
  email: "info@crestlinerisk.com",
  phones: ["+91 95825 39340", "+91 95571 24622"],
  address: "3rd Floor, C-18, Sector-2, Noida - 201301",
  gst: "09AANCC685A1ZL",
  businessType: "Collection DSA & Recovery Services",
};

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Leadership", href: "#leadership" },
  { label: "Process", href: "#process" },
  { label: "Contact", href: "#contact" },
];

export const SERVICES = [
  {
    key: "debt-collection",
    title: "Debt Collection",
    desc: "EMI, credit card, personal, auto and business loan recoveries with bucket-wise and pre-NPA / NPA collection management.",
    icon: "Money",
  },
  {
    key: "tele-soft",
    title: "Tele-Calling & Soft Collections",
    desc: "Reminder calls, payment follow-ups, settlement coordination, customer counselling and digital payment assistance.",
    icon: "Headset",
  },
  {
    key: "field-collection",
    title: "Field Collection",
    desc: "Doorstep collections, customer visits, recovery follow-ups, settlement discussions and acknowledgment handling.",
    icon: "MapPinLine",
  },
  {
    key: "skip-tracing",
    title: "Skip Tracing",
    desc: "Address verification, contact-number tracing, employment verification and alternate-contact identification.",
    icon: "MagnifyingGlass",
  },
  {
    key: "verification",
    title: "Verification Services",
    desc: "Residence, office and banking verification with dependable field investigation support across locations.",
    icon: "ShieldCheck",
  },
  {
    key: "portfolio",
    title: "Portfolio Management",
    desc: "Delinquent account management, recovery tracking, MIS reporting, strategy implementation and performance monitoring.",
    icon: "ChartLineUp",
  },
];

export const STATS = [
  { value: "21+", label: "Years of leadership experience" },
  { value: "110+", label: "Trained professionals" },
  { value: "200", label: "Seat operational capacity" },
  { value: "3", label: "States: Noida, Bihar, Odisha" },
];

export const PROCESS = [
  { no: "01", title: "Portfolio Allocation", desc: "Client shares the delinquent portfolio and recovery requirements for strategy mapping." },
  { no: "02", title: "Customer Contact", desc: "Tele-calling team initiates reminder calls and structured payment follow-ups." },
  { no: "03", title: "Field Visits", desc: "Field executives conduct customer visits for overdue recovery and verification." },
  { no: "04", title: "Resolution & Recovery", desc: "Settlement coordination and payment collection support to close accounts." },
  { no: "05", title: "Reporting", desc: "Regular MIS reports and recovery status updates are shared with clients." },
];

export const WHY_CHOOSE = [
  "RBI-compliant, ethical recovery practices",
  "Strict customer data confidentiality",
  "Daily MIS reporting & escalation system",
  "Customised collection strategies per client",
  "Multi-location operational support",
  "Quick turnaround with dedicated handling",
];

export const COMPLIANCE = [
  { code: "RBI-FPC", title: "RBI Guideline Adherence", desc: "Strict adherence to RBI Fair Practices Code while maintaining customer dignity." },
  { code: "DATA-SEC", title: "Data Confidentiality", desc: "Borrower data handled under strict confidentiality with controlled access." },
  { code: "PRO-COMM", title: "Professional Communication", desc: "Recorded, script-compliant communication standards across every interaction." },
  { code: "TRANSPARENT", title: "Transparent Process", desc: "Client-focused delivery with fully transparent, auditable operational processes." },
];

export const INDUSTRIES = [
  "Banks", "NBFCs", "Fintech Companies", "Microfinance Institutions",
  "Telecom Companies", "Insurance Companies", "E-commerce & Consumer Finance",
];

export const CLIENTS = [
  { name: "Lending Plate", status: "Active" },
  { name: "Bajaj Finance", status: "Active" },
  { name: "Khata Book", status: "Active" },
  { name: "L&T Finance", status: "Active" },
  { name: "Paisa Daily", status: "Active" },
  { name: "Rule Mudra", status: "Active" },
  { name: "Bright Loan", status: "Active" },
  { name: "Poonawalla Fincorp", status: "Active" },
];

export const DIRECTOR = {
  name: "Mr. Manas Kumar",
  role: "Director, Crestline Risk Management Pvt. Ltd.",
  bio: "With over 21 years of rich experience in collections and risk management, Mr. Manas Kumar has led portfolios at leading institutions including Citibank, Kotak Mahindra Bank, IDFC First Bank and Bajaj Finserv. He established Crestline with a vision to deliver effective, innovative and scalable recovery solutions.",
  brands: ["Citibank", "Kotak Mahindra Bank", "IDFC First Bank", "Bajaj Finserv"],
  portfolios: ["SME", "MBL", "Consumer Durable", "Credit Card", "Personal Loans", "Two-Wheeler", "Used Car Loans", "Cross-Sell"],
};
